/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_ShutterInputs */

const en_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shutter`)
};

const ar_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سرعة الغالق`)
};

const bn_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শাটার`)
};

const de_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschlusszeit`)
};

const es_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de obturación`)
};

const fr_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse d'obturation`)
};

const pt_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade do obturador`)
};

const zh_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快门`)
};

const tr_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enstantane`)
};

const ru_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выдержка`)
};

const pl_image_inspector_shutter = /** @type {(inputs: Image_Inspector_ShutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas migawki`)
};

/**
* | output |
* | --- |
* | "Shutter" |
*
* @param {Image_Inspector_ShutterInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_shutter = /** @type {((inputs?: Image_Inspector_ShutterInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_ShutterInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_shutter(inputs)
	if (locale === "bn") return bn_image_inspector_shutter(inputs)
	if (locale === "de") return de_image_inspector_shutter(inputs)
	if (locale === "es") return es_image_inspector_shutter(inputs)
	if (locale === "fr") return fr_image_inspector_shutter(inputs)
	if (locale === "pt") return pt_image_inspector_shutter(inputs)
	if (locale === "zh") return zh_image_inspector_shutter(inputs)
	if (locale === "tr") return tr_image_inspector_shutter(inputs)
	if (locale === "ru") return ru_image_inspector_shutter(inputs)
	if (locale === "pl") return pl_image_inspector_shutter(inputs)
	return en_image_inspector_shutter(inputs)
});